<template>
  <div id="app">
    <audio src="/music/test.mp3" id="audiosss" muted></audio>
    <audio src="/music/newOrder.mp3" id="newOrder" muted></audio>
    <audio src="/music/test.m4a" id="test" muted></audio>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :lock-scroll="true"
      :is-full-page="fullPage"
    ></loading>
    <router-view />
  </div>
</template>
<script>
import Echo from "laravel-echo";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Loading
  },
  data() {
    return {
      fullPage: true
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoad;
    }
  },
  methods: {
    setAutio() {
      document.getElementById("audiosss").muted = false;
      document.getElementById("newOrder").muted = false;
      window.removeEventListener("click", this.setAutio);
    }
  },
  mounted() {
    window.addEventListener("click", this.setAutio);
    setTimeout(() => {
      document
        .getElementById("test")
        .play()
        .catch(() => {
          console.error("通知");
          this.$alert("請點擊確認開啟通知", "通知", {
            confirmButtonText: "確認"
          });
        });
    }, 5000);
  },
  created() {
    function loadScript(src) {
      return new Promise((resolve, reject) => {
        var $script = document.createElement("script");
        $script.src = src;
        $script.onload = resolve;
        $script.onerror = reject;
        document.head.appendChild($script);
      });
    }
    if (window.Echo) {
      // 引入socket.js
      loadScript("/socket.io/socket.io.js")
        .then(() => {
          if (window.Echo) return;
          window.Echo = new Echo({
            broadcaster: "socket.io"
          });
        })
        .catch(() => {
          console.log("連線失敗");
        });
    }
    if (this.$cookie.get("token")) {
      this.$store.dispatch("getSelf");
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  color: #2c3e50;
}
#app .sidebar-container {
  -webkit-transition: width 0.28s;
  transition: width 0.28s;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
}
#app .main-container {
  min-height: 100%;
  -webkit-transition: margin-left 0.28s;
  transition: margin-left 0.28s;
  position: relative;
}

.page {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  align-items: center;
}
.pageWrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
.el-card__header {
  background-color: rgb(49, 64, 83);
  color: white;
}
table {
  thead {
    tr {
      background-color: red !important;
    }
  }
}
.el-table th {
  background-color: rgb(150, 164, 184) !important;
  color: white;
}
.el-table {
  margin-top: 10px;
}
.el-dialog__header {
  background-color: #304155;
  span {
    color: white;
  }
}
.title {
  margin-bottom: 1rem;
  // display: flex;
  // justify-content: space-between;
}
.sc-chat-window {
  z-index: 9;
}
.sc-launcher {
  z-index: 999;
}

.el-dialog__footer {
  padding: 0;
  .btnGroup {
    width: 100%;
    display: flex;
    .btn {
      padding: 10px;
      cursor: pointer;
      text-align: center;
      color: white;
      font-size: 16px;
      width: 50%;
      background-color: #304156;
      &:hover {
        background-color: #546577;
      }
    }
    .oBtn {
      padding: 10px;
      cursor: pointer;
      text-align: center;
      color: white;
      font-size: 16px;
      width: 100%;
      background-color: #304156;
      &:hover {
        background-color: #546577;
      }
    }
  }
}

@media (max-width: 768px) {
  .title {
    flex-direction: column;
    align-items: flex-start;
    .searchWrap {
      width: 100%;
    }
    .dashboard {
      margin-left: 0px !important;
      margin: 5px 0;
    }
  }
}
.indexGroup {
  // display: flex;
}

.closeDrawer {
  position: absolute;
  font-size: 30px;
  font-weight: bold;
  right: 10px;
  top: 15px;
  z-index: 999;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.el-form-item {
  margin-bottom: 15px !important;
}
.el-form--label-top .el-form-item__label {
  padding: 0 !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  overflow-x: hidden;
  color: #2c3e50;
}
#app .sidebar-container {
  -webkit-transition: width 0.28s;
  transition: width 0.28s;
  // width: 210px !important;
  // background-color: #304156;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
}
#app .main-container {
  min-height: 100%;
  -webkit-transition: margin-left 0.28s;
  transition: margin-left 0.28s;
  position: relative;
}

.pageWrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
table {
  thead {
    tr {
      background-color: red !important;
    }
  }
}
.el-table th {
  background-color: rgb(150, 164, 184) !important;
  color: white;
}
.el-table {
  margin-top: 10px;
}
.el-dialog__header {
  background-color: #304155;
  span {
    color: white;
  }
}
.title {
  margin-bottom: 1rem;
  // display: flex;
  // justify-content: space-between;
}
.sc-chat-window {
  z-index: 9;
}
.sc-launcher {
  z-index: 999;
}
@media (max-width: 768px) {
  .title {
    flex-direction: column;
    align-items: flex-start;
    .searchWrap {
      width: 100%;
    }
    .dashboard {
      margin-left: 0px !important;
      margin: 5px 0;
    }
  }
}
.indexGroup {
  // display: flex;
}
.el-dialog__footer {
  padding: 0;
  .btnGroup {
    width: 100%;
    display: flex;
    .btn {
      padding: 10px;
      cursor: pointer;
      text-align: center;
      color: white;
      font-size: 16px;
      width: 50%;
      background-color: #304156;
      &:hover {
        background-color: #546577;
      }
    }
    .oBtn {
      padding: 10px;
      cursor: pointer;
      text-align: center;
      color: white;
      font-size: 16px;
      width: 100%;
      background-color: #304156;
      &:hover {
        background-color: #546577;
      }
    }
  }
}

.content {
  margin: 20px;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  align-items: center;
}
.text-danger {
  color: red;
}
.text-center {
  text-align: center !important;
}
.copyHover {
  cursor: pointer;
}
.copyHover:hover {
  color: #409eff;
}
.text-right-input {
  .el-input__inner {
    text-align: right !important;
  }
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  height: auto !important;
}
.vac-card-window {
  height: 100% !important;
}
.el-table .tableWarnning {
  background: oldlace;
}
.tableNote {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.radioDate {
  display: flex;
  .radioDateRadio {
    display: flex;
    flex-direction: column;
    .el-radio {
      margin-bottom: 5px;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.video-js {
  width: 100% !important;
  max-height: 90vh;
}
.vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
}
.el-tooltip__popper {
  padding: 5px !important;
  padding-bottom: 0px important;
}
.el-badge__content.is-fixed {
  right: -10px !important;
  top: 48% !important;
}
.badd {
}
.el-descriptions-item__label.is-bordered-label {
  background-color: #96a4b8 !important;
  background: #96a4b8 !important;
  color: white;
  text-align: center !important;
}
.tableScroll::-webkit-scrollbar {
  display: none;
}

.dfControlWrap {
  .el-input {
    width: 100px;
    .el-input__inner {
      text-align: right !important;
    }
  }
}
.el-transfer {
  display: flex;
}
.dfControlWrap {
  .el-button + .el-button {
    margin-left: 0;
  }
}
.el-transfer__buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.el-input.is-disabled .el-input__inner {
  color: #606266;
}
.inputRight {
  input {
    text-align: right !important;
  }
}
.text-danger {
  color: red !important;
}
.pointer {
  cursor: pointer !important;
}
.radioForm {
  align-items: center;
  display: flex;
}
.radioWrap {
  display: flex;
  flex-direction: column;
}

.warningTable {
  background: oldlace !important;
  background-color: oldlace !important;
}

.nowrap {
  white-space: nowrap !important;
}
.w-50 {
  width: 50% !important;
}

.status0 {
  background: #e4e4e4 !important ;
  background-color: #e4e4e4 !important ;
}
.status1 {
  background: #adadff !important ;
  background-color: #adadff !important ;
}
.status2 {
  background: #bfe9bf !important ;
  background-color: #bfe9bf !important ;
}
.status3 {
  background: #efc0c0 !important;
  background-color: #efc0c0 !important;
}
</style>
